import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { constants } from '@clubmed/utils';
import { hasAtLeastOnePrice } from 'Components/utils/price/price.util';
import { useAppContext } from 'Context/ReactAppContext';
import { priceTicketRequest } from 'Store/priceTicket/priceTicket.actions';
import { getAllInclusiveServices } from 'Store/price-remote/all-inclusive-services/allInclusiveServices.actions';
import { getAdultsNumber } from 'Store/trip-information/storeHelper';
import {
  getDepartureCity,
  getTripDuration,
  getDepartureDate,
} from 'Store/trip-criteria/tripCriteria.selector';
import { allInclusiveServicesSelector } from 'Store/price-remote/all-inclusive-services/allInclusiveServices.selector';
import {
  getPriceTicketButton,
  getPriceTicketItems,
  getPriceTicketSubtitle,
} from './priceTicket.mapper';
import { PriceTicketContentWrapper } from './PriceTicketContentWrapper';
const { PRODUCT_TYPES } = constants;
export const MIN_HEIGHT = '4.25rem';
type Props = {
  cruise: null | Cruise;
  product: Product;
  travelAdvisorConfig: CMSTravelAdvisor;
};
export const PriceTicket = ({ cruise, product, travelAdvisorConfig }: Props) => {
  const appContext = useAppContext();
  const { query } = useRouter();
  const isLoading = useSelector<boolean>((state) => state.priceTicket.isLoading);
  const price = useSelector<ProductPrice>((state) => state.priceTicket.price);
  const allInclusiveServices = useSelector(allInclusiveServicesSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      priceTicketRequest({
        appContext,
        location: {
          origin: '',
          pathname: '',
          hash: '',
          urlParams: query as ProductUrlParams,
          queryParams: query as ProductQueryParams,
        },
        productId: product.id,
      }),
    );
  }, [product.id]);
  useEffect(() => {
    if (product.id && product.id === price?.productId) {
      dispatch(
        getAllInclusiveServices(appContext, {
          productId: product.id,
          accommodationId: price.termsAndConditions.accommodationId,
          includesTransportation: !!price.termsAndConditions.departureCity?.value,
        }),
      );
    }
  }, [product.id === price?.productId]);
  const fromStore = {
    adultsNumber: useSelector(getAdultsNumber),
    departureCity: useSelector(getDepartureCity),
    departureDate: useSelector(getDepartureDate),
    duration: useSelector(getTripDuration),
  };
  return (
    <PriceTicketContentWrapper
      allInclusiveServices={
        [PRODUCT_TYPES.SUMMER_CAMP, PRODUCT_TYPES.TOUR].includes(product.type)
          ? []
          : allInclusiveServices
      }
      button={getPriceTicketButton(product)}
      hasCallCenter={!hasAtLeastOnePrice(price)}
      isLoading={isLoading}
      items={getPriceTicketItems({
        fromStore,
        price,
        product,
      })}
      price={price}
      subtitle={getPriceTicketSubtitle(product, cruise)}
      title={product.name}
      id={product.id}
      travelAdvisorConfig={travelAdvisorConfig}
    />
  );
};
